export default function animateEfficiencyAccordion(container) {
  const accordionTitles = container.querySelectorAll("[data-id='efficiency-accordion-title']");
  const accordionDescriptions = Array.from(container.querySelectorAll("[data-id='efficiency-accordion-description']"));
  const plusIcons = Array.from(container.querySelectorAll("[data-id='efficiency-accordion-plus-icon']"));
  const minusIcons = Array.from(container.querySelectorAll("[data-id='efficiency-accordion-minus-icon']"));

  accordionTitles.forEach((accordionTitle, i) => {
    accordionTitle.addEventListener('click', () => {
      accordionDescriptions.forEach((_, j) => {
        if (i === j) {
          accordionDescriptions[j].classList.toggle('ws-accordion-hide-description');
          accordionDescriptions[j].classList.toggle('ws-accordion-show-description');
          plusIcons[j].classList.toggle('ws-accordion-hide-icon');
          minusIcons[j].classList.toggle('ws-accordion-hide-icon');
        } else {
          accordionDescriptions[j].classList.add('ws-accordion-hide-description');
          accordionDescriptions[j].classList.remove('ws-accordion-show-description');
          plusIcons[j].classList.remove('ws-accordion-hide-icon');
          minusIcons[j].classList.add('ws-accordion-hide-icon');
        }
      });
    });
  });
}
